var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.363,
    height: 16.363,
    viewBox: "0 0 16.363 16.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit",
    "data-name": "Icon feather-edit",
    transform: "translate(-2.5 -2.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M9.814,6h-5.3A1.514,1.514,0,0,0,3,7.514v10.6a1.514,1.514,0,0,0,1.514,1.514h10.6a1.514,1.514,0,0,0,1.514-1.514v-5.3",
    transform: "translate(0 -1.576)",
    fill: "none",
    stroke: "#593a7c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    d: "M19.95,3.288A1.606,1.606,0,0,1,22.222,5.56l-7.193,7.193L12,13.51l.757-3.029Z",
    transform: "translate(-4.457)",
    fill: "none",
    stroke: "#593a7c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0529c0aa.svg";
export { ForwardRef as ReactComponent };